import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { getVimeoIFrame } from "../components/vimeo";

function dm_h01() {

    // const h01_module = document.querySelector('section.h-01-main-header');

    // if (!h01_module) return false;


    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
    function reset_scroll_triggers(){
        $(window).trigger('resize');
        // ScrollTrigger.killAll();
        ScrollTrigger.refresh(true);
    }
    reset_scroll_triggers();

    const $isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    let $ww = $(window).width(),
        $body = $('body'),
        $vimeo_desktop = $('.h-01-main-header #vimeo-player'), $vimeo_mobile = $('.h-01-main-header  #vimeo-player-mobile'),
        // $vimeo_desktop_placeholder = $('.h-01-main-header .bg img.placeholder'), $vimeo_container = $('.h-01-main-header .hero-video.bg'),
        // $vimeo_desktop_wrap = $('.hero-video'),
        vimeoPlayer = $(".h01-video-wrap"),
        h01 = $('.h-01-main-header');

    if ( $vimeo_desktop.length && $vimeo_mobile.length ){
        if ( $isMobile && $ww < 1023 ){
            $vimeo_desktop.remove();
            // $vimeo_desktop_placeholder.remove();
            // $vimeo_container.addClass('mobile-video');
        } else {
            $vimeo_mobile.remove();
        }
    }

    // h01 animations
    if ($('body').hasClass('home')) {
        const $body = $('body');
        const overlay = $('#intro-overlay');
        const words = overlay.find('.intro-words span');

        if (!sessionStorage.getItem('introPlayed') && false ) { // DISABLE PRE-LOADER
            $body.addClass('animating header-out hide-logo');
            overlay.css('display', 'flex');

            words.each(function(i) {
                // const delay = i * 1.5;
                const delay = i * .75;
                $(this).css({
                    'transition-delay': `${delay}s`
                });
            });

            overlay.find('.intro-words').addClass('animated');
            const totalTime = (words.length * 2 + 1) * 500;
            setTimeout(() => overlay.addClass('fade-out'), totalTime);
            // setTimeout(() => $body.removeClass('header-out'), totalTime + 2000);
            // setTimeout(() => $body.removeClass('animating'), totalTime + 1000);
            setTimeout(() => $body.removeClass('header-out'), totalTime + 700);
            setTimeout(() => $body.removeClass('animating'), totalTime + 250);
            // setTimeout(() => $body.addClass('animated'), totalTime);
            setTimeout(() => $body.addClass('animated'), totalTime - 250);
            setTimeout(() => $body.removeClass('hide-logo'), totalTime + 1510);
            // setTimeout(() => $body.addClass('animated'), totalTime + 1000);
            // setTimeout(() => overlay.remove(), totalTime + 1500);
            setTimeout(() => overlay.remove(), totalTime + 249);

            sessionStorage.setItem('introPlayed', 'true');
        } else {
            // setTimeout(() => $body.removeClass('header-out'), 2000);
            $body.addClass('no-anim animated');
            $('#intro-overlay').remove();
        }
    }

    // Video modal.
    const h01VideoWrap = document.querySelector('.h01-video-wrap');
    if (h01VideoWrap) {
        h01VideoWrap.addEventListener('click', (event) => {
            currentTrigger = h01VideoWrap.querySelector('.video-trigger');
            $('#videoModal').modal('show');
        });
    }


    let currentTrigger = null;
    document.querySelectorAll('.video-trigger').forEach(trigger => {
        trigger.addEventListener('click', function () {
            if (currentTrigger) return;
            currentTrigger = this;
        });
    });
    const modal = document.getElementById('videoModal');
    if (modal) {
        const modalBody = modal.querySelector('.modal-body');
        modal.addEventListener('shown.bs.modal', function () {
            if (currentTrigger) {
                const vimeoId = currentTrigger.getAttribute('data-dm-vimeo-id');
                if (vimeoId) {
                    modalBody.innerHTML = getVimeoIFrame(vimeoId);
                }
            }
        });
        modal.addEventListener('hidden.bs.modal', function () {
            modalBody.innerHTML = '';
            currentTrigger = null;
        });
    }

    // Cursor.
    const videoCursor = document.getElementById('video-cursor');
    const videoWrap = document.querySelector('.h01-video-wrap');
    if (videoCursor && videoWrap) {
        videoWrap.addEventListener('mouseenter', () => {
            videoCursor.style.display = 'block';
        });

        videoWrap.addEventListener('mouseleave', () => {
            videoCursor.style.display = 'none';
        });

        videoWrap.addEventListener('mousemove', (e) => {
            videoCursor.style.left = (e.clientX + 50) + 'px';
            videoCursor.style.top = (e.clientY + 50) + 'px';
        });
    }
}

export { dm_h01 };
